'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/* \n* ink colors (with variations only for black and white)\n*/\n.lp-radio__wrapper {\n  display: flex;\n  align-items: center;\n  width: max-content;\n  padding: calc(0.25 * 1rem) calc(0.5 * 1rem);\n  border-radius: calc(0.5 * 1rem);\n}\n.lp-radio__wrapper:hover {\n  background: #f2f7ff;\n}\n.lp-radio__wrapper:focus {\n  background: #f2f7ff;\n  outline: none;\n}\n.lp-radio__wrapper .lp__radio {\n  margin-top: 0;\n  margin-right: calc(0.5 * 1rem);\n}");
//# sourceMappingURL=Radio.scss.js.map
